module.exports = __webpack_public_path__ + "static/media/search.448cdb4c.svg";